import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
import { List, Button } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import queries from '../../../utils/queries'
import actCartera from '../../../functions/actcartera';

import TitDer from '../../../components/funcionales/titder';

import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';
import EstaSeguro from '../../../components/funcionales/estaseguro'
var moment = require('moment');

const DetalleNivelLista2 = ({argsDocum, styles, elemento, handleChangePago}) => {
  let urlSlcm = 'https://montserratslcm.com/api/cotizaciones/'
  const rango1Ini = (valor) => {
    if(valor!==null){
      return valor
    }else{
      return 0
    }
  }
  let colorCelda='white'
  if(elemento.venceFact){
    let fechaHoy = new Date()
    fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    fechaHoy=moment(fechaHoy)
    var fecFin=moment(elemento.venceFact).format('YYYY-MM-DD')
    let numDias= fechaHoy.diff(fecFin, 'days') 
    if(numDias>0){
      colorCelda = 'red'
    }
  }

  return(
    <tr className=''>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          // href={'images/cotizaciones/' + elemento.archivoRecibido}
          href={urlSlcm + elemento.archivoRecibido}
            target="_blank">
          {elemento.archivoRecibido}
        </a>
      </td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}}>{elemento.numOrdenCompra}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}}>{elemento.numFactura}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}}>{elemento.numAvance}</td>
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          // href={'images/cotizaciones/' + elemento.archivoFactura}
          href={urlSlcm + elemento.archivoFactura}
            target="_blank">
          {elemento.archivoFactura}
        </a>
      </td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}}>{elemento.fechaSolic?elemento.fechaSolic.substr(0, 10):""}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}}>{elemento.valorFact?new Intl.NumberFormat('de-DE').format(elemento.valorFact):0}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}}>{elemento.venceFact?elemento.venceFact.substr(0, 10):""}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}}>{elemento.monedaCoti}</td>        
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}}>{elemento.valorPagado?new Intl.NumberFormat('de-DE').format(elemento.valorPagado):0}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}}>{elemento.valorFact?new Intl.NumberFormat('de-DE').format(elemento.valorFact-elemento.valorPagado):0}</td>
      <td className='center aligned' style={styles.styPaddMarg}>
        <input type='number' step="1" min="0" max="1" autoComplete="off" name="nuevoValor" id={elemento._id} value={rango1Ini(elemento.nuevoValor)} placeholder='Pagar (1)' onChange={(ev)=>handleChangePago(ev, elemento, argsDocum)}/>
      </td>
    </tr>
  )
};

const Lista = ({argsDocum, styles, list, handleChangePago}) => {
  const nivel2Detalle = list.map((elemento, _id) => <DetalleNivelLista2 argsDocum={argsDocum} styles={styles} elemento={elemento} handleChangePago={handleChangePago} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel2Detalle}
    </tbody>
  )
};

const ListaT = ({handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoPago" id="miLista" onChange={(ev)=>handleChange(ev)}>
        <option>Seleccionar...</option>
        <option>Transferencia</option>
        <option>Consignación</option>
        <option>Efectivo</option>
      </select>
    </div>
  )
};

class AdminPagosCli22 extends React.Component {    
  state={argsBuscCad: {}, lista: this.props.list,
    argsDocum: { 
      trmPago: this.props.trmHoy,
      fechaRegPago: this.props.fechaHoy,
      valorPago: 0,
      valorIVA: 0,
      valorRetencion: 0,
      valorAjuste: 0,
      valorPagoUS: 0,
      valorIVAUS: 0,
      valorRetencionUS: 0,
      valorAjusteUS: 0,
      observacionAjuste: '',
      totalFacturas: 0,
      totalIVA: 0,
      tipoPago: 'Seleccionar...'
    },
    ingresa: 'S',
    open: false, trmHoy: this.props.trmHoy,
    argsQuery5: `{$match: {tipoCoti: 'Cliente'}},
      {"$unwind": "$itemsFactura"},
      {$project: {_id: 1, numOrdenCompra: 1, estadoOC: 1, valorFact: '$itemsFactura.valorFact', 
      valorPagado: '$itemsFactura.valorPagado'
      }},
      {$group: {_id: {_id: '$_id', numOrdenCompra: '$numOrdenCompra', estadoOC: '$estadoOC'},
        valorTotalFact: {$sum: {$toDouble: '$valorFact'}}, valorTotalPago: {$sum: {$toDouble: '$valorPagado'}}
      }},
      {$project: {_id: '$_id._id', numOrdenCompra: '$_id.numOrdenCompra', estadoOC: '$_id.estadoOC',  
      valorFact: {$toDouble: '$valorTotalFact'}, valorPagado: {$toDouble: '$valorTotalPago'}
      }}`,
    argsQuery: `{$match: {tipoCoti: 'Cliente'}},
    {"$unwind": "$itemsFactura"},
    {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, pais: 1, 
    archivoEnviado: 1, archivoRecibido: 1, ordenCompraCliente: 1, monedaCoti: 1,
    estadoOC: 1, valorFact: '$itemsFactura.valorFact', 
    valorPagado: {
      $let: {
          vars: {valorPago: '$itemsFactura.valorPagado'},
          in: { $cond: { if: { $eq: [ "$$valorPago", null ] }, then: 0, else: "$$valorPago" } }
      }
    },
    valorFactSinIva: {
      $let: {
          vars: {valorSinIva: '$itemsFactura.valorFactSinIva'},
          in: { $cond: { if: { $eq: [ "$$valorSinIva", null ] }, then: 0, else: "$$valorSinIva" } }
      }
    },
      numAvance: {"$toString": "$itemsFactura.numAvance"}, numFactura: '$itemsFactura.numFactura', 
      venceFact: {$dateFromString: {dateString: "$itemsFactura.venceFact", format: "%Y-%m-%d"}}, archivoFactura: '$itemsFactura.archivoFactura',
      usuarioSolic: '$itemsFactura.usuarioSolic', fechaSolic: '$itemsFactura.fechaSolic', usuarioFact: '$itemsFactura.usuarioFact',
      fechaFact: '$itemsFactura.fechaFact', fechaPago: '$itemsFactura.fechaPago', usuarioPago: '$itemsFactura.usuarioPago'}},
    {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, numOrdenCompra: 1, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
    estadoOC: 1, valorFact: 1, valorFactSinIva: 1, valorPagado: 1, numAvance: 1, numFactura: 1, venceFact: 1, ordenCompraCliente: 1,
    archivoEnviado: 1, archivoRecibido: 1, archivoFactura: 1, monedaCoti: 1, pais: 1, 
    usuarioSolic: 1, fechaSolic: 1, usuarioFact: 1, fechaFact: 1, fechaPago: 1, usuarioPago: 1,
    totalOC: {
      $let: {
          vars: {valorFact: {$toDouble: '$valorFact'}, valorPagado: {$toDouble: '$valorPagado'}},
          in: { $subtract: [ "$$valorFact", "$$valorPagado" ] }
      }
    }
    }},
    {$match: {numFactura: {$ne: ""}, totalOC: {$gt: 0}}}, 
    {$sort: {descrEmpresa: 1, numOrdenCompra: 1, numAvance: 1}}`
  }

  handleChange = (ev) => {
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum

      argsDocum[ev.target.name] = ev.target.value
      if(ev.target.name === "valorPago"){
        argsDocum['valorPagoUS'] = parseFloat(ev.target.value/argsDocum.trmPago).toFixed(3)
      }
      if(ev.target.name === "valorIVA"){
        argsDocum['valorIVAUS'] = parseFloat(ev.target.value/argsDocum.trmPago).toFixed(3)
      }
      if(ev.target.name === "valorRetencion"){
        argsDocum['valorRetencionUS'] = parseFloat(ev.target.value/argsDocum.trmPago).toFixed(3)
      }
      if(ev.target.name === "valorAjuste"){
        argsDocum['valorAjusteUS'] = parseFloat(ev.target.value/argsDocum.trmPago).toFixed(3)
      }
      if(ev.target.name === "valorPagoUS"){
        argsDocum['valorPago'] = parseInt(ev.target.value * argsDocum.trmPago)
      }
      if(ev.target.name === "valorIVAUS"){
        argsDocum['valorIVA'] = parseInt(ev.target.value * argsDocum.trmPago)
      }
      if(ev.target.name === "valorRetencionUS"){
        argsDocum['valorRetencion'] = parseInt(ev.target.value * argsDocum.trmPago)
      }
      if(ev.target.name === "valorAjusteUS"){
        argsDocum['valorAjuste'] = parseInt(ev.target.value * argsDocum.trmPago)
      }

      this.setState({argsDocum});
      this.setState({ingresa: "N"})
  }

  handleChangePago = async (ev, elemento, argsDocum) => {
    if(ev.target.name === "nuevoValor"){
      let valorNuevo=ev.target.value
      let listItem=this.state.lista
      let valorIVA=0
      const indexSearch = listItem.findIndex(buscaOrden => buscaOrden._id === elemento._id);
      if(indexSearch !== -1){
        console.log(listItem[indexSearch])
        if(listItem[indexSearch].nuevoValor !== ev.target.value){
          if(!listItem[indexSearch].valorFactSinIva || listItem[indexSearch].valorFactSinIva=='' || listItem[indexSearch].valorFactSinIva==null || listItem[indexSearch].valorFactSinIva===0){
            let argsBuscar=""
            argsBuscar += `'numOrdenCompra': ${listItem[indexSearch].numOrdenCompra}`
            let argsBuscarIt = {}
            argsBuscarIt = {tipoqry: `[{$match: {tipoCoti: 'Cliente', numOrdenCompra: ${listItem[indexSearch].numOrdenCompra}}},
            {"$unwind": "$itemsDespacho"},
            {$project: {_id: 1, descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, pais: 1, 
              descrProductoDes: '$itemsDespacho.descrProductoDes', porcDctoDes: '$itemsDespacho.porcDctoDes', idProducto: '$itemsDespacho.idProducto', 
              valorDes: '$itemsDespacho.valorDes', cantidad: '$itemsDespacho.cantidad', porcIncrementoDes: '$itemsDespacho.porcIncrementoDes', 
              porcIVADes: '$itemsDespacho.porcIVADes', despFact: '$itemsDespacho.despFact', codAvance: {"$toString": '$itemsDespacho.codAvance'}}},   
            {$project: {_id: {$concat: ['$numCoti', '$descrProductoDes', '$despFact', '$codAvance']}, 
              descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, descrProductoDes: 1, porcDctoDes: 1, pais: 1,  
              idProducto: 1, porcIVADes: 1, valorDes: 1, cantidad: 1, porcIncrementoDes: 1, estadoComision: 1, despFact: 1, codAvance: 1}}, 
            {$match: {despFact: 'F', codAvance: '${listItem[indexSearch].numAvance}'}}]`}
            let {data} = await this.props.allCotizacionRtes6.refetch(argsBuscarIt)
            let registros = await data.allCotizacionRtes
            console.log(registros)
            const elemento3 = registros
            elemento3.forEach((elemento, i) => {
              let valorItem=elemento.cantidad * elemento.valorDes
              if(elemento.porcIncrementoDes>0){
                valorItem=Math.round((valorItem/((100-elemento.porcIncrementoDes)/100)) * 100) / 100
              }
              if(elemento.porcDctoDes>0){
                valorItem=Math.round((valorItem*((100-elemento.porcDctoDes)/100)) * 100) / 100
              }
              let valorItemSinIva = valorItem
              if(elemento.porcIVADes>0){
                valorItem=Math.round((valorItem+((valorItem*elemento.porcIVADes)/100)) * 100) / 100
                valorIVA+=valorItem-valorItemSinIva
              }
            })
          }else{
            valorIVA=listItem[indexSearch].valorFact-listItem[indexSearch].valorFactSinIva
          }
          if(valorNuevo==='01' || parseInt(valorNuevo) === 1 || (listItem[indexSearch].nuevoValor===0 && (valorNuevo=='' || valorNuevo==null))){
            console.log(listItem[indexSearch].valorFact, listItem[indexSearch].valorFactSinIva)
            listItem[indexSearch].nuevoValor = 1
            if(!listItem[indexSearch].totalOC || listItem[indexSearch].totalOC=='' || listItem[indexSearch].totalOC==null || listItem[indexSearch].totalOC===0){
              argsDocum['totalFacturas']+=Math.round((listItem[indexSearch].valorFact-valorIVA) * 100) / 100
            }else{
              argsDocum['totalFacturas']+=Math.round((listItem[indexSearch].totalOC-valorIVA) * 100) / 100
            }
            argsDocum['totalIVA']+=valorIVA
          }else{
            console.log(listItem[indexSearch].nuevoValor, ev.target.value)
            if(parseInt(valorNuevo) === 0 || (listItem[indexSearch].nuevoValor===1 && (valorNuevo=='' || valorNuevo==null))){
              listItem[indexSearch].nuevoValor = 0
              if(!listItem[indexSearch].totalOC || listItem[indexSearch].totalOC=='' || listItem[indexSearch].totalOC==null || listItem[indexSearch].totalOC===0){
                argsDocum['totalFacturas']-=Math.round((listItem[indexSearch].valorFact-valorIVA) * 100) / 100
              }else{
                argsDocum['totalFacturas']-=Math.round((listItem[indexSearch].totalOC-valorIVA) * 100) / 100
              }
              argsDocum['totalIVA']-=valorIVA
            }
          }
          console.log(listItem[indexSearch].nuevoValor)
          this.setState({lista: listItem});
        }
      }
    }
  }

  handlePagar = async (ev, items, argsDocum)=>{
    if(argsDocum.tipoPago==="Seleccionar..."){
      alert("!! Deben seleccionar el medio de pago !!")
    }else{
      if(argsDocum.valorPago===0 && argsDocum.valorAjuste===0){
        alert("!! No hay pago o ajuste para registrar !!")
      }else{
        if(parseInt(argsDocum.valorPago)===0 && parseInt(argsDocum.valorRetencion)>0){
          alert("!! No puede existir retención si no hay pago !!")
        }else{
          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha
          const errors = [];
          if(items.length>0){
            const elemento3 = items
            let lista = []
            let cuentaItems=0, totalPago=0
            let moneda=''
            elemento3.forEach((elemento, i) => {
              if(parseInt(elemento.nuevoValor)>0){
                lista[cuentaItems]=elemento
                let monedaItem=elemento.monedaCoti?elemento.monedaCoti:'Pesos'
                if(cuentaItems===0){
                  moneda=elemento.monedaCoti?elemento.monedaCoti:'Pesos'
                }else{
                  if(moneda!==monedaItem){
                    moneda='NA'
                  }
                }
                if(!lista[cuentaItems].totalOC || lista[cuentaItems].totalOC=='' || lista[cuentaItems].totalOC==null || lista[cuentaItems].totalOC===0){
                  totalPago+=Math.round(lista[cuentaItems].valorFact * 100) / 100 
                }else{
                  totalPago+=Math.round(lista[cuentaItems].totalOC * 100) / 100 
                }
// console.log(totalPago)
                cuentaItems+=1
              }
            }) 

            if(lista.length>0){
              if(moneda!=='NA'){
// console.log(argsDocum)
                let retencion=0, ajuste=0
                let totalPagado=0
                if(moneda==='Dolares'){
                  totalPagado=(Math.round(argsDocum.valorPagoUS * 100)/100) + (Math.round(argsDocum.valorIVAUS * 100)/100) + (Math.round(argsDocum.valorRetencionUS * 100)/100) + (Math.round(argsDocum.valorAjusteUS * 100)/100)
                  retencion=argsDocum.valorRetencionUS
                  ajuste=argsDocum.valorAjusteUS
                }else{
                  totalPagado=(Math.round(argsDocum.valorPago * 100)/100) + (Math.round(argsDocum.valorIVA * 100)/100) + (Math.round(argsDocum.valorRetencion * 100)/100) + (Math.round(argsDocum.valorAjuste * 100)/100)
                  retencion=argsDocum.valorRetencion
                  ajuste=argsDocum.valorAjuste
                }                  

                if((Math.round(totalPago * 100)/100)===(Math.round(totalPagado * 100)/100)){
                  document.body.style.cursor = 'wait'
                  lista.forEach(async (elemento, i) => {
                    let pagado=lista[i].valorFact
                    let modEstado = 'N'

                    const argsUpd = {
                      numOrdenCompra: parseInt(elemento.numOrdenCompra),
                      numAvance: parseInt(elemento.numAvance),
                      valorPagado: pagado,
                      tipoAct: 'EditarItemFact2'
                    }

                    const response = await this.props.editCotizacion({
                      variables: argsUpd
                    });
                    const {errors, success} = response.data.editCotizacion;
                    if (!success){
                      this.setState({errorAdd: errors})
                    }else{
                      let valPago=0, valIVA=0
                      let porcPago=0, valRet=0, valAju=0
                      if(!elemento.totalOC || elemento.totalOC=='' || elemento.totalOC==null || elemento.totalOC===0){
                        porcPago=(elemento.valorFact*100)/totalPagado
                      }else{
                        porcPago=(elemento.totalOC*100)/totalPagado
                        valPago=elemento.totalOC 
                      }
                      if(!elemento.valorFactSinIva || elemento.valorFactSinIva=='' || elemento.valorFactSinIva==null || elemento.valorFactSinIva===0){
                        valPago=elemento.valorFact 
                      }else{
                        valPago=elemento.valorFactSinIva 
                        valIVA=elemento.valorFact-elemento.valorFactSinIva
                      }
                      // console.log(retencion)
                      if(parseInt(retencion)>0){
                        valRet=(retencion*porcPago)/100
                        valPago-=Math.round(valRet * 100) / 100
                      }
                      // console.log(ajuste)
                      if(parseInt(ajuste)>0){
                        valAju=(ajuste*porcPago)/100
                        valPago-=Math.round(valAju * 100) / 100
                      }
// console.log(totalPagado, porcPago, valPago, valIVA, valRet, valAju, retencion, ajuste)
                      const argsUpdPago = {
                        numOrdenCompra: parseInt(elemento.numOrdenCompra),
                        valorPago: Math.round(valPago * 100) / 100,
                        valorIVA: Math.round(valIVA * 100) / 100,
                        valorRetencion: Math.round(valRet * 100) / 100,
                        valorAjuste: Math.round(valAju * 100) / 100,
                        observacionAjuste: argsDocum.observacionAjuste?argsDocum.observacionAjuste:'',
                        tipoPago: argsDocum.tipoPago,
                        codiAvance: parseInt(elemento.numAvance),
                        usuarioRegPago: localStorage.getItem('userLogin'),
                        fechaRegPago: argsDocum.fechaRegPago,
                        cliProv: 'C',
                        trmPago: argsDocum.trmPago?argsDocum.trmPago.replace(/\,/g,'.'):0,
                        tipoAct: "CrearItemPago"
                      }            
                      let response = await this.props.editCotizacion({
                        variables: argsUpdPago
                      });
                      const {errors, success} = response.data.editCotizacion;
                      if (!success){
                        this.setState({errorAdd: errors})
                      }else{
                          this.props.allCotizacionRtes6.refetch()                          
                          let argsBuscar=""
                          argsBuscar += `'numOrdenCompra': ${elemento.numOrdenCompra}`
                          let argsBuscarIt = {}
                          argsBuscarIt = {tipoqry: `[${this.state.argsQuery5}, {$match: {${argsBuscar}}}]`}
                          console.log(argsBuscarIt)
                          let {data} = await this.props.allCotizacionRtes6.refetch(argsBuscarIt)
                          let registros = await data.allCotizacionRtes
                          const elemento3 = registros
                          elemento3.forEach((factura, i) => {
                            let valF = factura.valorFact
                            let valP = factura.valorPagado
                            let estadoOC = factura.estadoOC
                            if(parseInt(valF)===parseInt(valP) && estadoOC!=='Aprobada'){
                                modEstado = 'S'
                            }
                          })
                          
                        // }
                      }
                      if(modEstado === 'S'){
                        const argsUpdFac = {
                          numOrdenCompra: parseInt(elemento.numOrdenCompra),
                          estadoOC: 'Pagada',
                          tipoAct: 'EditarFact',
                        }
                        const response = await this.props.editCotizacion({
                          variables: argsUpdFac
                        });
                        const {errors, success} = response.data.editCotizacion;
                        if (!success){
                          this.setState({errorAdd: errors})
                        }else{
                          console.log("Pagada")
                        }            
                      }

                      await actCartera(
                        elemento.descrEmpresa,
                        {
                          allCotizacionRtes: this.props.allCotizacionRtes, 
                          editEmpresa: this.props.editEmpresa 
                        }
                      );

                    }
                  })
                  var tipoPago = document.getElementById("miLista");
                  tipoPago.options.selectedIndex = 0

                  argsDocum['valorPago'] = 0
                  argsDocum['valorIVA'] = 0
                  argsDocum['valorRetencion'] = 0
                  argsDocum['valorAjuste'] = 0
                  argsDocum['valorPagoUS'] = 0
                  argsDocum['valorIVAUS'] = 0
                  argsDocum['valorRetencionUS'] = 0
                  argsDocum['valorAjusteUS'] = 0
                  argsDocum['totalFacturas'] = 0
                  argsDocum['totalIVA'] = 0
                  
                  let argsBuscar = {}
                  argsBuscar = {tipoqry: `[${this.state.argsQuery}]`}

                  document.body.style.cursor = 'default'

                  alert("!! Pago registrado !!")

                  let {data} = await this.props.allCotizacionRtesPagos.refetch(argsBuscar)
                  let registros = await data.allCotizacionRtes
                  let listaNueva = []
                  const elemento3 = registros
                  elemento3.forEach((elemento, i) => {
                    listaNueva.push({numOrdenCompra: elemento.numOrdenCompra, 
                      ordenCompraCliente: elemento.ordenCompraCliente,
                      numCoti: elemento.numCoti, 
                      monedaCoti: elemento.monedaCoti, 
                      estadoOC: elemento.estadoOC, 
                      descrEmpresa: elemento.descrEmpresa, 
                      numAvance: elemento.numAvance, 
                      consecAvance: elemento.consecAvance,
                      fechaSolic: elemento.fechaSolic, 
                      valorFact: elemento.valorFact, 
                      valorFactSinIva: elemento.valorFactSinIva, 
                      valorPagado: elemento.valorPagado, totalOC: elemento.totalOC,
                      numFactura: elemento.numFactura, 
                      venceFact: elemento.venceFact, 
                      pais: elemento.pais,
                      archivoFactura: elemento.archivoFactura?elemento.archivoFactura:'',
                      archivoRecibido: elemento.archivoRecibido?elemento.archivoRecibido:'',
                      nuevoValor: 0, nuevoValor1: 0, nuevoValor2: 0, nuevoValor3: 0, _id: i
                    });
                  }) 
                  this.setState({lista: listaNueva})



                  // this.setState({lista: registros})
                }else{
                  alert("!! Los valores totales no son iguales a la suma de los valores de los items !!")
                }
              }else{
                alert("!! No puede incluir en el pago facturas de diferente moneda !!")
              }  
            }else{
              alert("!! No existen productos a Facturar !!")
            }
          }else{
            alert("!! No existen productos a Facturar !!")
          }
        }
      }
    } 
  }


  handleQuestionUpdDel = async (ev, btn) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidMount(){
      let lista = []
      if(this.state.ingresa==="S"){
        const elemento3 = this.props.list
        elemento3.forEach((elemento, i) => {
          lista.push({numOrdenCompra: elemento.numOrdenCompra, 
            ordenCompraCliente: elemento.ordenCompraCliente,
            numCoti: elemento.numCoti, 
            monedaCoti: elemento.monedaCoti, 
            estadoOC: elemento.estadoOC, 
            descrEmpresa: elemento.descrEmpresa, 
            numAvance: elemento.numAvance, 
            consecAvance: elemento.consecAvance,
            fechaSolic: elemento.fechaSolic, 
            valorFact: elemento.valorFact, 
            valorFactSinIva: elemento.valorFactSinIva, 
            valorPagado: elemento.valorPagado, totalOC: elemento.totalOC,
            numFactura: elemento.numFactura, 
            venceFact: elemento.venceFact, 
            pais: elemento.pais,
            archivoFactura: elemento.archivoFactura?elemento.archivoFactura:'',
            archivoRecibido: elemento.archivoRecibido?elemento.archivoRecibido:'',
            nuevoValor: 0, nuevoValor1: 0, nuevoValor2: 0, nuevoValor3: 0, _id: i
          });
        }) 
        this.setState({lista, ingresa: "N"})
      }
  }

  async componentDidUpdate(prevProps, prevState){
      let lista = []
      if(this.state.ingresa==="S"){
        const elemento3 = this.props.list
        elemento3.forEach((elemento, i) => {
          lista.push({numOrdenCompra: elemento.numOrdenCompra, 
            ordenCompraCliente: elemento.ordenCompraCliente,
            numCoti: elemento.numCoti, 
            monedaCoti: elemento.monedaCoti, 
            estadoOC: elemento.estadoOC, 
            descrEmpresa: elemento.descrEmpresa, 
            numAvance: elemento.numAvance, 
            consecAvance: elemento.consecAvance,
            fechaSolic: elemento.fechaSolic, 
            valorFact: elemento.valorFact, 
            valorFactSinIva: elemento.valorFactSinIva, 
            valorPagado: elemento.valorPagado, totalOC: elemento.totalOC,
            numFactura: elemento.numFactura, 
            venceFact: elemento.venceFact, 
            pais: elemento.pais,
            archivoFactura: elemento.archivoFactura?elemento.archivoFactura:'',
            archivoRecibido: elemento.archivoRecibido?elemento.archivoRecibido:'',
            nuevoValor: 0, nuevoValor1: 0, nuevoValor2: 0, nuevoValor3: 0, _id: i
          });
        }) 
        this.setState({lista, ingresa: "N"})
      }
  }

  render (){
    const {argsDocum, confirmaAct, open, trmHoy, permiteBtn1, permiteBtn2} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let list = []
    argsDocum.trmPago=argsDocum.trmPago.replace(",", ".")
    console.log(this.state.ingresa, this.state.lista,this.props.allCotizacionRtesPagos.allCotizacionRtes)
    list = this.state.lista
    let fechaRegPago = new Date(argsDocum.fechaRegPago)
    fechaRegPago = (fechaRegPago.getFullYear()) + '-' + ((fechaRegPago.getMonth()+1)<10?'0'+(fechaRegPago.getMonth()+1):(fechaRegPago.getMonth()+1)) + '-' + (fechaRegPago.getUTCDate()<10?'0'+fechaRegPago.getUTCDate():fechaRegPago.getUTCDate())
   
    const a357805 = this.props.autorizacUA.findIndex( autorizac => autorizac === "357805" );
    const a357810 = this.props.autorizacUA.findIndex( autorizac => autorizac === "357810" );
    // console.log(a357805, a357810)
    if(list){
      if(a357805!==-1){
        list = list.filter(elemento => elemento.pais==='Colombia')
      }else{
        if(a357810!==-1){
          list = list.filter(elemento => elemento.pais==='Panamá')
        }
      }
    }

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Facturación pendiente de pago
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" >
            <div className="ui eleven column stackable grid">
              <div className="row container">
              <div className="column" style={{width: '10%', paddingTop: '0.8em'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Fecha de pago</label>
                    <input style={this.props.styles} type='date' name="fechaRegPago" id="fechaRegPago" value={fechaRegPago} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '10%', paddingTop: '0.8em'}}>                
                  <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Medio de pago</label>
                    <ListaT handleChange={this.handleChange} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '9%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor pago $</label>
                      <input type='number' step="0.01" min="0" autoComplete="off" name="valorPago" id="valorPago" value={argsDocum.valorPago} placeholder='Valor pago' onChange={this.handleChange}/>
                    </Form.Field>                
                </div> 
                <div className="column" style={{width: '9%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor Impto $</label>
                      <input type='number' step="0.01" min="0" autoComplete="off" name="valorIVA" id="valorIVA" value={argsDocum.valorIVA} placeholder='Valor Impto' onChange={this.handleChange}/>
                    </Form.Field>                
                </div> 
                <div className="column" style={{width: '9%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor retención $</label>
                      <input type='number' step="0.01" min="0" autoComplete="off" name="valorRetencion" id="valorRetencion" value={argsDocum.valorRetencion} placeholder='Valor retención' onChange={this.handleChange}/>
                    </Form.Field>                
                </div>
                <div className="column" style={{width: '9%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor ajuste $</label>
                      <input type='number' step="0.01" min="0" autoComplete="off" name="valorAjuste" id="valorAjuste" value={argsDocum.valorAjuste} placeholder='Valor ajuste' onChange={this.handleChange}/>
                    </Form.Field>                
                </div> 
                <div className="column" style={{width: '9%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor pago $US</label>
                      <input type='number' step="0.001" min="0" autoComplete="off" name="valorPagoUS" id="valorPagoUS" value={argsDocum.valorPagoUS} placeholder='Valor pago' onChange={this.handleChange}/>
                    </Form.Field>                
                </div> 
                <div className="column" style={{width: '9%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor Impto $US</label>
                      <input type='number' step="0.001" min="0" autoComplete="off" name="valorIVAUS" id="valorIVAUS" value={argsDocum.valorIVAUS} placeholder='Valor Impto' onChange={this.handleChange}/>
                    </Form.Field>                
                </div>
                <div className="column" style={{width: '8%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor ret. $US</label>
                      <input type='number' step="0.001" min="0" autoComplete="off" name="valorRetencionUS" id="valorRetencionUS" value={argsDocum.valorRetencionUS} placeholder='Valor retención' onChange={this.handleChange}/>
                    </Form.Field>                
                </div>
                <div className="column" style={{width: '9%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor ajuste $US</label>
                      <input type='number' step="0.001" min="0" autoComplete="off" name="valorAjusteUS" id="valorAjusteUS" value={argsDocum.valorAjusteUS} placeholder='Valor ajuste' onChange={this.handleChange}/>
                    </Form.Field>                
                </div>
                <div className="column" style={{width: '8%', paddingTop: '0.8em'}}>
                  <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>TRM recaudo</label>
                    <input type='number' step="0.001" min="0" autoComplete="off" name="trmPago" id="trmPago" value={argsDocum.trmPago} placeholder='TRM' onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '50%', paddingTop: '0.8em'}}>
                  <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Observaciones al ajuste</label>
                    <input style={this.props.styles.input} autoComplete="off" name="observacionAjuste" id="observacionAjuste" value={argsDocum.observacionAjuste} onChange={this.handleChange} placeholder='Observaciones'/>
                  </Form.Field>
                </div>       
                <div className="column" style={{width: '25%', paddingTop: '0.8em'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Total facturas: &nbsp;&nbsp;{new Intl.NumberFormat('de-DE').format((argsDocum.totalFacturas))}
                  </p>                
                </div>
                <div className="column" style={{width: '25%', paddingTop: '0.8em'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Total IVA: &nbsp;&nbsp;{new Intl.NumberFormat('de-DE').format((argsDocum.totalIVA))}
                  </p>                
                </div>
              </div>
            </div> 
            </Form>
        </div>

        <List selection>
          <TitDer list={list} textBoton1="Facturas pendientes de recaudo" btnNuevo={"NO"} styles={this.props.styles}/>

          <div style={{height: '35em', overflow: 'auto'}}>
            <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
              <thead className=''>
                <tr className=''>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Cliente</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Archivo OC cliente</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>No. Orden de compra LCM</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>No. Factura</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>No. Avance</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Archivo factura</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Fecha solic.</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Valor fact.</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Fecha vencimiento factura</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Moneda</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Vlr pagado</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Saldo</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Pagar (1)</th>
                </tr>
              </thead>
              <Lista argsDocum={argsDocum} styles={this.props.styles} list={list} handleChangePago={this.handleChangePago}/>
            </table>
          </div>
        </List>

        <div className="ui five column stackable grid">
          <div className="row container">            
            <div className="column" style={{width: '100%', paddingTop: '0em'}}>
              <Button id="pagar" name="pagar" style={{...this.props.styles.confirmar, height: '2.1em'}} onClick={(ev)=>this.handlePagar(ev, list, argsDocum)} fluid>
                REGISTRAR PAGO
              </Button>
            </div>                 
          </div>
        </div>

      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes'}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesPagos',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente'}},
    {"$unwind": "$itemsFactura"},
    {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, pais: 1, 
    archivoEnviado: 1, archivoRecibido: 1, ordenCompraCliente: 1, monedaCoti: 1,
    estadoOC: 1, valorFact: '$itemsFactura.valorFact', 
    valorPagado: {
      $let: {
          vars: {valorPago: '$itemsFactura.valorPagado'},
          in: { $cond: { if: { $eq: [ "$$valorPago", null ] }, then: 0, else: "$$valorPago" } }
      }
    },
    valorFactSinIva: {
      $let: {
          vars: {valorSinIva: '$itemsFactura.valorFactSinIva'},
          in: { $cond: { if: { $eq: [ "$$valorSinIva", null ] }, then: 0, else: "$$valorSinIva" } }
      }
    },
      numAvance: {"$toString": "$itemsFactura.numAvance"}, numFactura: '$itemsFactura.numFactura', 
      venceFact: {$dateFromString: {dateString: "$itemsFactura.venceFact", format: "%Y-%m-%d"}}, archivoFactura: '$itemsFactura.archivoFactura',
      usuarioSolic: '$itemsFactura.usuarioSolic', fechaSolic: '$itemsFactura.fechaSolic', usuarioFact: '$itemsFactura.usuarioFact',
      fechaFact: '$itemsFactura.fechaFact', fechaPago: '$itemsFactura.fechaPago', usuarioPago: '$itemsFactura.usuarioPago'}},
    {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, numOrdenCompra: 1, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
    estadoOC: 1, valorFact: 1, valorFactSinIva: 1, valorPagado: 1, numAvance: 1, numFactura: 1, venceFact: 1, ordenCompraCliente: 1,
    archivoEnviado: 1, archivoRecibido: 1, archivoFactura: 1, monedaCoti: 1, pais: 1, 
    usuarioSolic: 1, fechaSolic: 1, usuarioFact: 1, fechaFact: 1, fechaPago: 1, usuarioPago: 1,
    totalOC: {
      $let: {
          vars: {valorFact: {$toDouble: '$valorFact'}, valorPagado: {$toDouble: '$valorPagado'}},
          in: { $subtract: [ "$$valorFact", "$$valorPagado" ] }
      }
    }
    }},
    {$match: {numFactura: {$ne: ""}, totalOC: {$gt: 0}}}, 
    {$sort: {descrEmpresa: 1, numOrdenCompra: 1, numAvance: 1}}
    ]`}}}}),
  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),
  graphql(queries.mutation.editEmpresa, {name:'editEmpresa'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
  

)(AdminPagosCli22)
